<template>
  <div>
    <OrderTable
      ref="orderTable"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      :type="type"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        perfect
        size="mini"
        align="right"
        slot="pager"
        :layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage']"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </OrderTable>
  </div>
</template>

<script>
import OrderTable from './table.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import { request } from '@/api/service'
export default {
  mixins: [BaseTable],
  components: { PageHeader, OrderTable },
  props: {
    type: { type: String, default: 'radio' },
    url: { default: '/factory/orderInfo/list', type: String },
    methods: { type: String, default: 'POST' },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      const params = { ...form, ...this.page }
      request({
        url: this.url,
        method: this.methods,
        data: 'POST' === this.methods ? params : null,
        params: 'GET' === this.methods ? params : null,
      })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    choiceData() {
      return this.$refs.orderTable.choiceData()
    },
  },
}
</script>
